import { makeAutoObservable, flow } from "mobx";

export default class AppState {
  author = "";
  name = "";
  isPrivateOnly = false;
  isSubmitting = false;

  constructor(booksStore) {
    makeAutoObservable(this, { submit: flow.bound }, { autoBind: true });
    this.booksStore = booksStore;
  }

  get books() {
    return this.booksStore[this.isPrivateOnly ? "privateBooks" : "allBooks"];
  }

  get privateBooksCount() {
    return this.booksStore.privateBooks.length;
  }

  get isSubmittable() {
    return Boolean(this.author && this.name && !this.isSubmitting);
  }

  setAuthor(author) {
    this.author = author;
  }

  setName(name) {
    this.name = name;
  }

  setIsPrivateOnly(isPrivateOnly) {
    this.isPrivateOnly = isPrivateOnly;
  }

  *submit(event) {
    event.preventDefault();

    if (!this.isSubmittable) {
      return;
    }

    this.isSubmitting = true;

    try {
      yield this.booksStore.addBook({ name: this.name, author: this.author });
      this.author = "";
      this.name = "";
    } finally {
      this.isSubmitting = false;
    }
  }
}
